import { DateTime } from 'luxon'

const paths = {
    orders_v2: '/mercadolibre/ventas',
    shipments: '/mercadolibre/ventas',
    messages: '/mercadolibre/ventas',
    questions: '/mercadolibre/preguntas',
    payments: '/mercadolibre/pagos',
    claims: '/mercadolibre/devoluciones',
    items: '/mercadolibre/publicaciones',
    items_prices: '/mercadolibre/publicaciones',
    user_products: '/mercadolibre/publicaciones',
    'user-products-families': '/mercadolibre/publicaciones',
    user_products_families: '/mercadolibre/publicaciones',
    'stock-locations': '/mercadolibre/publicaciones',
    'stock-location': '/mercadolibre/publicaciones',
    price_suggestion: '/mercadolibre/publicaciones',
    price_suggestions: '/mercadolibre/publicaciones',
    stock_locations: '/mercadolibre/publicaciones',
    catalog: '/mercadolibre/publicaciones',
    invoices: '/mercadolibre/ventas',
    'flex-handshakes': '/mercadolibre/ventas',
    returns: '/mercadolibre/devoluciones',
}

const icons = {
    orders_v2: 'mdi mdi-sale',
    shipments: 'mdi mdi-truck-delivery',
    messages: 'mdi mdi-message-text',
    questions: 'mdi mdi-message-question',
    payments: 'mdi mdi-cash',
    claims: 'mdi mdi-alert-circle-outline',
    items: 'mdi mdi-newspaper',
    items_prices: 'mdi mdi-tag-outline',
    user_products: 'mdi mdi-package-variant',
}

const titles = {
    orders_v2: 'Orden actualizada',
    shipments: 'Envío actualizado',
    messages: 'Mensaje recibido',
    questions: 'Pregunta recibida',
    payments: 'Pago actualizado',
    claims: 'Reclamo actualizado',
    items: 'Publicación actualizada',
    items_prices: 'Precio actualizado',
    user_products: 'Producto actualizado',
}

const isClaimNotice = (notification) => {
    const topic = notification.topic?.toLowerCase()
    return topic === 'claims' || topic === 'claims_actions' ||
        topic === 'post_purchase' && notification.resource?.includes('/claims/')
}

export const notificationPath = (notification) => {
    if (isClaimNotice(notification)) return '/mercadolibre/devoluciones'
    const topic = notification.topic?.toLowerCase() ?? ''
    if (paths[topic]) return paths[topic]
    if (/order|shipment|shipping|message|invoice|flex/.test(topic)) return '/mercadolibre/ventas'
    if (/question/.test(topic)) return '/mercadolibre/preguntas'
    if (/payment/.test(topic)) return '/mercadolibre/pagos'
    if (/claim|return|refund/.test(topic)) return '/mercadolibre/devoluciones'
    if (/item|product|price|stock|catalog|promotion/.test(topic)) return '/mercadolibre/publicaciones'
    return '/notificaciones'
}
export const notificationIcon = (notification) => isClaimNotice(notification) ? icons.claims :
    icons[notification.topic?.toLowerCase()] ?? 'ri-information-line'
export const notificationTitle = (notification) => notification.title ||
    (isClaimNotice(notification) ? titles.claims : titles[notification.topic?.toLowerCase()]) ||
    `Cambio en Mercado Libre: ${notification.topic || 'recurso'}`
export const notificationBody = (notification) => (notification.body || '')
    .replace(/\s*\(recurso [^)]+\)\.?/i, '')
    .replace(/^Recurso:\s*/i, '')
    .trim()
export const notificationResource = (notification) => {
    const id = notification.entityId || notification.resource?.split('/').filter(Boolean).at(-1) || ''
    if (!id) return ''
    const topic = notification.topic?.toLowerCase() ?? ''
    const label = /order/.test(topic) ? 'orden' : /shipment/.test(topic) ? 'envío' :
        /question/.test(topic) ? 'pregunta' : /payment/.test(topic) ? 'pago' :
        isClaimNotice(notification) || /claim|return/.test(topic) ? 'reclamo' :
        /message/.test(topic) ? 'mensaje' : 'publicación'
    return /^ML[A-Z]{1,3}\d+$/i.test(String(id)) ? id : `${label} ${id}`
}
export const notificationTime = (notification) => {
    const raw = notification.processedAt || notification.occurredAt || notification.sent || notification.received
    if (!raw) return 'Fecha no disponible'
    const time = DateTime.fromISO(raw)
    return time.isValid ? time.toFormat('hh:mm a | dd/MM/yyyy') : raw
}
